import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    '&&': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  paperWrapper: {
    '&&': {
      position: 'relative',
      maxHeight: 'calc(100vh - 80px)',

      borderRadius: '15px',

      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.down('tablet')]: {
        width: 'calc(100vw - 40px)',

        padding: '40px 30px',

        gap: SPACES.xxxxl,
      },
      [theme.breakpoints.up('tablet')]: {
        maxWidth: 'calc(100vw - 40px)',
        minWidth: '728px',

        padding: '72px 40px',

        gap: 50,
      },
    },
  },
  closeButton: {
    '&&': {
      borderRadius: '50%',
      position: 'absolute',

      [theme.breakpoints.down('tablet')]: {
        top: 0,
        right: 0,
      },
      [theme.breakpoints.up('tablet')]: {
        top: 4,
        right: 4,
      },
    },
  },
  title: {
    '&&': {
      alignSelf: 'center',

      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
      textAlign: 'center',

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.xxxl,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xxxxxl,
      },
    },
  },
  formWrapper: {
    '&&': {
      overflow: 'auto',

      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxxxl,
    },
  },
  inputSection: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.l,
    },
  },
  inputTitle: {
    '&&': {
      alignSelf: 'center',

      fontWeight: FONTS.WEIGHTS.medium,
      color: theme.palette.custom.darkBlue2,
      textAlign: 'center',

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.xl,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xxl,
      },
    },
  },
  buttonWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '60px',
    },
  },
  modalButton: {
    '&&': {
      borderRadius: '15px',

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      paddingLeft: SPACES.m,
      paddingRight: SPACES.m,
    },
  },
  modalButtonLight: {
    '&&': {
      border: `1px solid ${theme.palette.custom.primary}`,
      backgroundColor: theme.palette.custom.white,
      color: theme.palette.custom.primary,
    },
  },
  generationWrapper: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('mobile_l')]: {
      gap: SPACES.xs,

      alignItems: 'center',
    },
    [theme.breakpoints.up('mobile_l')]: {
      alignItems: 'flex-end',
    },
  },
}))

export { useStyles }
